import React from "react";
import { AdyenCorpPersAdvancedFlow } from "@components";

const AdyenCorpPers = ({
  isCorporate,
  paymentParameters, // { amount, currency, reference, returnUrl, … }
  onSuccess,
  processingUrl,
  onError,
  externalSubmitRef,
  onAmountChange, // New callback for amount changes
  setLoading, // Simple loading state setter
  onCardTypeChange, // New callback for card type detection
  onAmexChange, // New callback for Amex detection
  onCardBrandChange, // Callback for notifying if a recognised card brand has been entered
  onCardNotAllowed,
  onStorePaymentDetails,
  setProcessing,
  disablePayment,
  setBinLookupPending,
}) => {
  return (
    <AdyenCorpPersAdvancedFlow
      isCorporate={isCorporate}
      paymentParameters={paymentParameters}
      externalSubmitRef={externalSubmitRef}
      processingUrl={processingUrl}
      onSuccess={onSuccess}
      onError={onError}
      onAmountChange={onAmountChange}
      setLoading={setLoading}
      onCardTypeChange={onCardTypeChange}
      onAmexChange={onAmexChange}
      onCardBrandChange={onCardBrandChange}
      onCardNotAllowed={onCardNotAllowed}
      onStorePaymentDetails={onStorePaymentDetails}
      disablePayment={disablePayment}
      setProcessing={setProcessing}
      setBinLookupPending={setBinLookupPending}
    />
  );
};

export { AdyenCorpPers };
